(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function(){
  const init = (sectionEl)=>{
    if (!sectionEl || sectionEl.dataset.faqEnhanced === '1') return;
    sectionEl.dataset.faqEnhanced = '1';
    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = Array.from(sectionEl.querySelectorAll('details.faq-item'));

    const closeItem = (det)=>{
      const content = det.querySelector('.faq-content');
      if(!content){ det.removeAttribute('open'); return; }
      if(!det.hasAttribute('open')) return;
      if(prefersReduce){ det.removeAttribute('open'); return; }
      const start = content.scrollHeight;
      content.style.height = start + 'px';
      requestAnimationFrame(()=>{
        content.style.height = '0px';
        const done = ()=>{ content.removeEventListener('transitionend', done); det.removeAttribute('open'); };
        content.addEventListener('transitionend', done);
      });
    };

    const openItem = (det)=>{
      const content = det.querySelector('.faq-content');
      if(!content) return;
      items.forEach((other)=>{ if(other !== det) closeItem(other); });
      if(det.hasAttribute('open')) return;
      if(prefersReduce){ det.setAttribute('open',''); return; }
      det.setAttribute('open','');
      content.style.height = '0px';
      requestAnimationFrame(()=>{
        const end = content.scrollHeight;
        content.style.height = end + 'px';
        const done = ()=>{ content.removeEventListener('transitionend', done); content.style.height = 'auto'; };
        content.addEventListener('transitionend', done);
      });
    };

    items.forEach((det)=>{
      const content = det.querySelector('.faq-content');
      if(det.hasAttribute('open') && content){ content.style.height = content.scrollHeight + 'px'; }
      const summary = det.querySelector('summary');
      if(!summary) return;
      const onActivate = (ev)=>{
        if (ev.type === 'keydown' && !(ev.key === 'Enter' || ev.key === ' ')) return;
        ev.preventDefault();
        det.hasAttribute('open') ? closeItem(det) : openItem(det);
      };
      summary.addEventListener('click', onActivate);
      summary.addEventListener('keydown', onActivate);
    });
  };

  const ready = ()=>{
    document.querySelectorAll('[id^="shopify-section-"]').forEach((section)=>{
      if (section.querySelector('.faqs-bg')) init(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', (e)=>{
    const section = document.getElementById(e.detail.sectionId);
    if (section && section.querySelector('.faqs-bg')) init(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
